// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"UK-z","carouselContainer":"VK-z"};